/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ImageAddIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Image Add',
} = {}): string | TemplateResult => {
  return html`<svg
    data-name="ICONS"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.5,7.52114c0,.82843-.67157,1.5-1.5,1.5s-1.5-.67157-1.5-1.5.67157-1.5,1.5-1.5,1.5.67157,1.5,1.5h0Z"
      fill="currentColor"
    />
    <path
      d="M15,10.5c-2.48529,0-4.5,2.01471-4.5,4.5s2.01471,4.5,4.5,4.5,4.5-2.01471,4.5-4.5-2.01471-4.5-4.5-4.5ZM17.5,15.625h-1.875v1.875c0,.34473-.28027.625-.625.625s-.625-.28027-.625-.625v-1.875h-1.875c-.34473,0-.625-.28027-.625-.625s.28027-.625.625-.625h1.875v-1.875c0-.34473.28027-.625.625-.625s.625.28027.625.625v1.875h1.875c.34473,0,.625.28027.625.625s-.28027.625-.625.625Z"
      fill="currentColor"
    />
    <path
      d="M16.75,3H3.25c-1.24023,0-2.25,1.00977-2.25,2.25v9.5c0,1.24023,1.00977,2.25,2.25,2.25h5.08984c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75H3.25c-.41309,0-.75-.33691-.75-.75v-1.16895l2.96973-2.96875c.29297-.29297.76758-.29297,1.06055,0l1.91504,1.91504c.29297.29297.76758.29297,1.06055,0s.29297-.76758,0-1.06055l-1.91504-1.91504c-.87695-.87695-2.30469-.87695-3.18164,0l-1.90918,1.90869v-6.21045c0-.41309.33691-.75.75-.75h13.5c.41309,0,.75.33691.75.75v3.84668c0,.41406.33594.75.75.75s.75-.33594.75-.75v-3.84668c0-1.24023-1.00977-2.25-2.25-2.25h0Z"
      fill="currentColor"
    />
  </svg>`;
};
